module.exports = __webpack_public_path__ + "static/tamaryn-3ab705cfbf1717a25cb39648be266388.jpg";